<template>
  <div class="login">
    <form class="form" @submit.prevent="handleSubmit">
      <div class="form__img">
        <img alt="logo" src="../assets/logo_quick_pay_2022.png" />
        <p>Compra en tus tiendas favoritas</p>
        <span>Más facil, rápido y seguro</span>
      </div>
      <div class="form__inputs">
        <div class="input">
          <input
            type="number"
            class="no-arrow"
            placeholder="N° documento"
            v-model="user_doc_number"
            style="outline: none"
          />
          <i class="fas fa-id-card"></i>
        </div>

        <div class="input">
          <input
            type="text"
            placeholder="Nombre"
            v-model="user_name"
            style="outline: none"
          />
          <i class="fas fa-user-circle"></i>
        </div>

        <div class="input">
          <input
            type="text"
            placeholder="Apellido"
            v-model="user_lastname"
            style="outline: none"
          />
          <i class="fas fa-user-circle"></i>
        </div>

        <div class="input">
          <input
            type="text"
            placeholder="Codigo pais"
            v-model="cellphone_code"
            style="outline: none"
          />
          <i class="fas fa-phone"></i>
        </div>

        <div class="input">
          <input
            type="text"
            placeholder="Celular"
            v-model="cellphone"
            style="outline: none"
          />
          <i class="fas fa-phone"></i>
        </div>

        <div class="input">
          <input
            type="text"
            placeholder="  Fecha de nacimiento"
            onfocus="(this.type='date')"
            v-model="birthday_date"
            style="outline: none; width: 100%"
          />
        </div>

        <div class="input">
          <input
            type="text"
            placeholder="Correo"
            v-model="email"
            style="outline: none"
          />
          <i class="fas fa-envelope"></i>
        </div>

        <div class="input">
          <input
              :type='show1?"text":"password"'
            placeholder="Contraseña"
            v-model="password"
            style="outline: none"
          />
          <p @click="showPasswrd1" style="margin-bottom: 0px">
            <a class="fas fa-lock"></a>
          </p>
        </div>

        <div class="input">
          <input
              :type='show2?"text":"password"'
            placeholder="Repetir contraseña"
            v-model="password_confirmation"
            style="outline: none"
          />
          <p @click="showPasswrd2" style="margin-bottom: 0px">
            <a class="fas fa-lock"></a>
          </p>
        </div>

        <button>Guardar</button>
      </div>
    </form>
  </div>
</template>

<script>
  // @ is an alias to /src
  import axios from 'axios'

  export default {
    name: 'Register',
    components: {},
    data: function () {
      return {
        user: '',
        show1: false,
        show2: false,
        user_doc_number: '',
        user_name: '',
        user_lastname: '',
        email: '',
        password: '',
        password_confirmation: '',
        cellphone_code: '',
        cellphone: '',
        birthday_date: ''
      }
    },
    methods: {
      showPasswrd1(){
        if(this.show1 === true){
          this.show1 = false
        }else {
          this.show1 = true
        }
      },
      showPasswrd2(){
        if(this.show2 === true){
          this.show2 = false
        }else {
          this.show2 = true
        }
      },
      async handleSubmit() {
        const data ={
          "user_doc_type_id": 1,
          "user_doc_number": this.user_doc_number,
          "user_name": this.user_name,
          "user_lastname": this.user_lastname,
          "email": this.email,
          "password": this.password,
          "password_confirmation": this.password_confirmation,
          "role_id": "1",
          "birthday_date": this.birthday_date,
          "cellphone_code": this.cellphone_code,
          "cellphone": this.cellphone
        }
        const response = await axios.post('register', data)

        this.$router.push('/login')
      }
    }
  }
</script>

<style scoped>
  /*------LOGIN------*/
  .login {
    width: 100vw;
    height: 100vh;
    display: flex;
    flex-direction: column;
    justify-content: center;
    align-items: center;
    font-family: 'Readex Pro', sans-serif;
  }
  .no-arrow {
    -moz-appearance: textfield;
  }
  .no-arrow::-webkit-inner-spin-button {
    display: none;
  }
  .no-arrow::-webkit-outer-spin-button,
  .no-arrow::-webkit-inner-spin-button {
    -webkit-appearance: none;
    margin: 0;
  }
  .form {
    width: 500px;
    height: 100%;
    display: flex;
    flex-direction: column;
    align-items: center;
  }

  .form__img {
    width: 100%;
    height: 250px;
    display: flex;
    flex-direction: column;
    align-items: center;
  }

  .form__img img {
    width: 300px;
  }

  .form__img p {
    margin: 0;
    font-size: 20px;
    font-weight: 600;
    color: #ff3128;
  }

  .form__img span {
    margin: 0;
    font-size: 15px;
    font-weight: 300;
  }

  .form__inputs {
    width: 100%;
    height: 100%;
    display: flex;
    margin-top: 20px;
    /*flex-direction: column;*/
    flex-wrap: wrap;
    align-content: flex-start;
  }

  .form__inputs .input {
    width: 49%;
    height: 10%;
    margin: 6px auto;
    /*margin-bottom: 4px;*/
    border: 1px solid #f1f1f1;
    border-radius: 15px;
    /*padding: 15px;*/
    display: flex;
    align-items: center;
    /*justify-content: space-between;*/
    justify-content: center;
  }

  .form__inputs .input input {
    border: none;
  }

  .form__inputs button {
    width: 90%;
    margin: 10px auto;
    border: none;
    border-radius: 10px;
    background: #ff3128;
    color: #fff;
    padding: 15px 10px;
    font-weight: 600;
  }

  .form__inputs .remember_account {
    width: 85%;
    margin: 15px auto;
    display: flex;
    justify-content: space-between;
    align-items: center;
  }
  .form__inputs .remember_account p {
    margin: 0;
  }

  @media (max-width: 768px) {
    .form__inputs {
      width: 75%;
      height: 100%;
      display: flex;
      margin-top: 20px;
      align-content: flex-start;
      flex-direction: column;
      flex-wrap: nowrap;
    }
    .form__inputs .input {
      width: 80%;
      height: 10%;
      margin: 6px auto;
      /*margin-bottom: 4px;*/
      border: 1px solid #f1f1f1;
      border-radius: 15px;
      /*padding: 15px;*/
      display: flex;
      align-items: center;
      /*justify-content: space-between;*/
      justify-content: center;
    }
  }


  /*------LOGIN------*/
</style>
